import actions from './actions';

const initState = {
    banner   : {},
    loading : false,
    errorMessage: null
};

export default function createOrUpdateBannerReducer(state = initState, action) {
    switch (action.type) {
        case actions.CREATE_OR_UPDATE_BANNER_REQUESTED:
            return {
                ...state,
                banner   : {},
                loading : true
            };
        case actions.CREATE_OR_UPDATE_BANNER_SUCCEEDED:

            return {
                ...state,
                banner   : action.banner,
                loading    : false
            };
        case actions.CREATE_OR_UPDATE_BANNER_FAILED:
            return {
                ...state,
                loading : false,
                errorMessage: action.error
            };
        default:
            return state;
    }
}
